import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';

const useStyles = makeStyles(theme => ({
  wrap: {
    '& h4': {
      userSelect: 'none',
    },
  },
  test: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  answers: {
    width: 300,
    '& svg': {
      color: theme.palette.secondary.main,
    },
  },
  no: {
    width: 60,
    height: 60,
    borderRadius: '50%',
    background: theme.palette.primary.main,
    fontSize: '1.25em',
    color: '#fff',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: 1,
    userSelect: 'none',
  },
  buttons: {
    '& button': {
      margin: theme.spacing(1),
    },
  }
}));

function TestABC (props) {
  const classes = useStyles();
  const { q, a, setAnswer } = props;

  const renderAnswer = (ans, ansText) => {
    return (
      <ListItem dense button onClick={() => setAnswer(ans)}>
        <ListItemIcon>
          <Checkbox checked={a === ans} />
        </ListItemIcon>
        <ListItemText primary={ansText} />
      </ListItem>
    );
  }

  return (
    <div className={classes.wrap}>
      <div className={classes.test}>
        <h4>{q.sentence}</h4>
        <List className={classes.answers}>
          {renderAnswer('a', q.a)}
          {renderAnswer('b', q.b)}
          {renderAnswer('c', q.c)}
        </List>
      </div>
    </div>
  );
}

export default TestABC;
